import CloseIcon from '@mui/icons-material/Close';
import { Dialog, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';

interface DialogTitleProps {
  id?: string;
  children?: React.ReactNode;
  onClose?: () => void;
}

const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, id } = props;
  return (
    <MuiDialogTitle
      id={id}
      component="div"
      sx={{
        m: 0,
        p: 2.5,
        position: 'relative',
      }}
    >
      <h2 className="text-base font-normal tracking-normal">{children}</h2>
      {onClose ? (
        <IconButton
          aria-label="close"
          sx={(theme) => ({
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
          })}
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

interface ConfirmModalProps {
  isOpen: boolean;
  onClose(...args: unknown[]): unknown;
  onConfirm?(...args: unknown[]): unknown;
  modalTitle?: string;
  onCancel?(...args: unknown[]): unknown;
  children?: React.ReactNode;
  actions?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  background?: 'default' | 'transparent' | 'dark';
  confirmText?: string;
  cancelText?: string;
}

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm = () => {},
  onCancel = () => {},
  confirmText = 'Ja',
  cancelText = 'Nei',
  children = null,
  maxWidth = 'lg',
  modalTitle = 'Mer informasjon',
  background = 'default',
  actions = false,
  ...dialogProps
}: ConfirmModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={maxWidth}
      {...dialogProps}
      slotProps={{
        paper: {
          sx: (theme) => ({
            width: '100%',
            // margin: spacing(4, 0) on xs, spacing(4) on sm+
            m: {
              xs: `${theme.spacing(4)} 0`,
              sm: theme.spacing(4),
            },
            ...(background === 'default' && {
              backgroundColor: theme.palette.background.paper,
              color: (theme as any).palette.text.default,
            }),
            ...(background === 'dark' && {
              backgroundColor: '#031839 !important',
              color: '#fff',
              height: 'auto',
            }),
            ...(background === 'transparent' && {
              backgroundColor: 'transparent',
              color: (theme as any).palette.text.contrast,
            }),
          }),
        },
      }}
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose}>
        {modalTitle}
      </DialogTitle>
      <MuiDialogContent>{children}</MuiDialogContent>
      {actions ? (
        <MuiDialogActions>
          <Button autoFocus onClick={onCancel} color="primary">
            {cancelText}
          </Button>
          <Button autoFocus onClick={() => onConfirm()} color="primary">
            {confirmText}
          </Button>
        </MuiDialogActions>
      ) : (
        <MuiDialogActions />
      )}
    </Dialog>
  );
};

export default ConfirmModal;
